/** Trim only: the backend compares names exactly, so being stricter would reject names it accepts. */
export const normalizeAdUnitName = (name: string): string => name.trim()

export const isDuplicatedAdUnitName = (adUnits: { name: string }[], value: string): boolean => {
  const name = normalizeAdUnitName(value)
  if (!name) return false
  // Counting with an early exit rather than filtering: this runs once per field on every keystroke
  let occurrences = 0
  for (const adUnit of adUnits) {
    if (normalizeAdUnitName(adUnit.name) === name && ++occurrences > 1) return true
  }
  return false
}

export const toSubmittableAdUnitNames = (adUnits: { name: string }[]): string[] => adUnits.map((adUnit) => normalizeAdUnitName(adUnit.name)).filter(Boolean)
